export default "__VITE_ASSET__Bj53Oksl__"